export default {
  //Admin
  //apiUrl: apiUrl
  apiUrl: apiUrl

  //Demo
  //apiUrl: apiUrl


  //Data free
  //apiUrl: apiUrl
}
